import {
  BankOutlined,
  CreditCardOutlined,
  FundOutlined,
  GiftFilled,
  GiftOutlined,
  IdcardOutlined,
  MessageOutlined,
  SnippetsOutlined,
  TransactionOutlined,
  UserOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import { ReactComponent as IconBonuses } from "assets/icons/Bonus.svg";
import { ReactComponent as IconsDownload } from "assets/icons/download_mobile.svg";
import { ReactComponent as IconFAQ } from "assets/icons/FAQ.svg";
import { ReactComponent as IconAbout } from "assets/icons/Info.svg";
import { ReactComponent as IconLoyaltyProgram } from "assets/icons/Loyalty.svg";
import { ReactComponent as IconNews } from "assets/icons/News.svg";
import ResponsiveGamingIcon from "assets/icons/ResponsiveGaming";
import { ReactComponent as IconRules } from "assets/icons/Rule.svg";

import { PATH } from "./path";

export const LIST_PROFILE = [
  { icon: UserOutlined, name: "My Profile", link: PATH.user.profile },
  { icon: IdcardOutlined, name: "Account", link: PATH.user.account },
  { icon: CreditCardOutlined, name: "Deposit", link: PATH.user.deposit },
  {
    icon: BankOutlined,
    name: "Bank",
    link: PATH.user.bank,
  },
  {
    icon: TransactionOutlined,
    name: "Cart Withdrawal",
    link: PATH.user.cashWithdraw,
  },
  {
    icon: SnippetsOutlined,
    name: "Transaction History",
    link: PATH.user.transactionHistory,
  },
  { icon: GiftFilled, name: "My Bonuses", link: PATH.user.myBonus },
  {
    icon: GiftOutlined,
    name: "Bonus History",
    link: PATH.user.bonusHistory,
  },
  {
    icon: VerticalAlignBottomOutlined,
    name: "Documents",
    link: PATH.user.documents,
  },
  { icon: MessageOutlined, name: "Messages", link: "/" },
  { icon: FundOutlined, name: "Tournaments", link: PATH.tournamentsPage },
];

export const LIST_GAMES = [
  { icon: IdcardOutlined, name: "Live Casino", link: PATH.gameLivePage },
  { icon: CreditCardOutlined, name: "Slots", link: PATH.gameSlotsPage },
  { icon: CreditCardOutlined, name: "E-Sport", link: PATH.gameESportPage },
  { icon: UserOutlined, name: "Sport", link: PATH.gameSportPage },
];

export const LIST_LINK = [
  {
    icon: IconFAQ,
    name: "FAQ",
    link: PATH.info.faq,
    key: 1,
  },
  {
    icon: ResponsiveGamingIcon,
    name: "Responsive Gaming",
    link: PATH.info.responsibleGaming,
    key: 2,
  },
  {
    icon: IconRules,
    name: "Rules",
    link: PATH.info.bettingRules,
    key: 3,
  },
  {
    icon: IconAbout,
    name: "About",
    link: PATH.info.about,
    key: 4,
  },
  {
    icon: IconNews,
    name: "News",
    link: PATH.newsPage,
    key: 5,
  },
  {
    icon: IconBonuses,
    name: "Bonuses",
    link: PATH.bonusPage,
    key: 6,
  },
  {
    icon: IconLoyaltyProgram,
    name: "Loyalty Program",
    link: PATH.user.loyaltyProgram,
    key: 7,
  },
  {
    icon: IconsDownload,
    name: "Download App",
    link: "",
    key: 8,
  },
];
